// @ts-nocheck
import { groupBy, uniq } from 'lodash';
import React from 'react';

import { DataLayer } from '@/components/Map/components/DataLayer';

type LayerMapDataItem = {
  [key: string]: any;
  _id: string;
  cartographyLevel: string;
  cartographyLevelId: string;
  country: string;
  w: number;
};

type Props = {
  id: string;
  indexLimits: { max: number; min: number };
  layerMapData: LayerMapDataItem[];
  opacity?: number;
  paintLimits?: boolean;
  promoteId?: string;
  type: string;
};

const MultiCountryLevelDataLayer: React.VFC<Props> = ({
  id,
  indexLimits,
  layerMapData,
  opacity = 0.5,
  paintLimits = false,
  promoteId,
  type
}) => {
  const groupedLayerMapDataByCountry: Record<string, LayerMapDataItem[]> = groupBy(layerMapData, 'country');
  const groupedLayerMapData: Record<string, Record<string, LayerMapDataItem[]>> = {};
  Object.entries(groupedLayerMapDataByCountry).forEach(([countryCode, data]) => {
    groupedLayerMapData[countryCode] = groupBy(data, 'cartographyLevel');
  });

  return (
    <>
      {Object.entries(groupedLayerMapData).reduce<React.ReactNode[]>(
        (prev, [country, countryLayerMapData]) => [
          ...prev,
          ...Object.entries(countryLayerMapData).map(([shape, shapeMapData]) => (
            <DataLayer
              country={country}
              id={`${id}_${country}_${shape}`}
              indexLimits={indexLimits}
              key={`${id}_${country}_${shape}`}
              layerMapData={shapeMapData.map(({ cartographyLevelId, ...rest }) => ({
                ...rest,
                _id: cartographyLevelId
              }))}
              opacity={opacity}
              paintLimits={paintLimits}
              promoteId={promoteId}
              shape={shape}
              tagFilters={{ [shape]: uniq(shapeMapData.map(i => i.cartographyLevelId)) }}
              type={type}
            />
          ))
        ],
        []
      )}
    </>
  );
};

export default MultiCountryLevelDataLayer;
